import Bingo from "./Bingo.png";
import FeuxArtifices from "./FeuxArtifices.png";
import Halloween from "./Halloween.png";
import Noel from "./Noel.png";
import PartyHawaienSimple from "./PartyHawaienSimple.png";
import KarineLauzon from "./karine_lauzon.jpeg";
import Texarkansas from "./texarkansas.png";

interface Event {
  date: Date;
  title: string;
  description?: string;
  hours?: string;
  cost?: string[];
  admission?: string;
  signer?: string;
  images?: string[];
  subitems?: SubEvent[];
}

interface SubEvent {
  title: string;
  hours: string;
  cost?: string[];
  admission?: string;
  images?: string[];
}

export const EVENTS: Event[] = [
  {
    date: new Date("2026-05-30 12:00"),
    title: "Bingo",
    hours: "à 19h00",
    images: [Bingo],
    cost: [
      "5$ par personne (inclut 2 cartes pour les 10 tours)",
      "1$ par carte additionnelle valide pour 2 tours",
    ],
    admission: "pour tous",
  },
  {
    date: new Date("2026-06-27 12:00"),
    title: "Saint-Jean",
    description: "Musique, feux d'artifices et feu de camp",
    hours: "de 20h00 à minuit",
    images: [FeuxArtifices],
    subitems: [
      {
        title: "Groupe : Texarkansas",
        hours: "de 20h00 à minuit",
        images: [Texarkansas],
      },
    ],
  },
  {
    date: new Date("2026-07-25 12:00"),
    title: "Noël des campeurs",
    description: "Jeu gonflable toute la journée",
    images: [Noel],
    subitems: [
      {
        title: "Cadeaux pour les enfants",
        hours: "à 14h00",
      },
      {
        title: "Souper de Noël version Potluck",
        hours: "à 18h00",
      },
      {
        title: "Échange de cadeaux d'une valeur d'environ 20$",
        hours: "après le souper",
      },
    ],
  },
  {
    date: new Date("2026-08-01 12:00"),
    title: "Party hawaïen",
    description: "Au bord de la piscine",
    images: [PartyHawaienSimple],
    subitems: [
      {
        title: "Avec Karine Lauzon et Stéphane",
        hours: "à partir de 13h30",
        images: [KarineLauzon],
      },
      {
        title: "Hot dog",
        hours: "à 18h00",
        admission: "pour tous",
      },
    ],
  },
  {
    date: new Date("2026-08-29 12:00"),
    title: "Halloween des campeurs",
    description: "Décorez et déguisez vous pour le plaisir des tout petits !!!",
    images: [Halloween],
    subitems: [
      {
        title: "Cueillette de bonbons pour les enfants",
        hours: "à 14h00",
      },
    ],
  },
];
